module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', [_c('input-with-validation', {
    ref: "emailInput",
    attrs: {
      "type": "email",
      "label": "Email Address",
      "regex": '^.{1,255}[@].{1,255}[.].{1,255}$',
      "required": true,
      "loading": _vm.loading,
      "failure-msg": "Please enter a valid email address",
      "name": "email",
      "value": _vm.value
    },
    on: {
      "input": _vm.input
    }
  }), _vm._v(" "), (_vm.suggestedValue) ? _c('small', {
    staticClass: "input__suggest-value"
  }, [_vm._v("\n      Did you mean "), _c('span', {
    on: {
      "click": _vm.useSuggestedValue
    }
  }, [_vm._v(_vm._s(_vm.suggestedValue))]), _vm._v("?\n  ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97f2199a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emailInput.vue
// module id = 611
// module chunks = 0